<div class="page-shell">
  <div class="page">
    <div class="hero">
      <div class="hero-text">
        <span class="eyebrow">Registration</span>
        <h2>Get started with datastor.io</h2>
        <p>Tell us about your tenant and we will prepare your workspace.</p>
      </div>
      <div class="hero-panel">
        <div class="step-pill">Step 1 of 1</div>
        <div class="hero-title">Tenant details</div>
        <div class="hero-subtitle">This takes about two minutes.</div>
      </div>
    </div>

    <section class="card">
      @switch (currentStep$ | async) {
      @case ('tenantInfo') {
      <app-tenant-info [startingForm]="userForm.get('tenantInfo')?.value" [finalForm]="true" [status]="status"
        (subformInitialized)="subformInitialized('tenantInfo', $event)" (submitForm)="submitForm()"></app-tenant-info>
      }
      }
    </section>
  </div>
</div>